module.exports = __webpack_public_path__ + "static/circ-about-us-84053fb9bc34e729e9386a436f28c488.mp4";